import React from "react";
import { Tabs } from 'antd';
import LabTaskList from "./LabTaskList";
import LabRecievingLatexList from "./LabRecievingLatexList";
import LabPondList from "./LabPondList";
import LabStorageTankList from "./LabStorageTankList";
import LabSkimList from "./LabSkimList";
import LabTruckHistoryView from "./LabTruckHistoryView";

export default function LabLatexView() {

  const items = [
    {
      key: 'ถาดงาน',
      label: 'การ์ดงานเข้า',
      children: <LabTaskList/>,
    },
    {
      key: 'latex',
      label: 'น้ำยางสด',
      children: <LabTruckHistoryView/>,
    },
    {
      key: 'pond',
      label: 'บ่อพักน้ำยางสด',
      children: <LabPondList/>,
    },
    {
      key: 'tank',
      label: 'แทงก์',
      children: <LabStorageTankList/>,
    },
    {
      key: 'skim',
      label: 'สกิม',
      children: <LabSkimList/>,
    },
  ];

  return(
    <div style={{ marginTop : 20}}>
      <Tabs 
        destroyInactiveTabPane
        defaultActiveKey="task" 
        items={items} 
      />

    </div>
  )
}